import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../providers/logincontext';

const ProtectedRoute = () => {
  const { accessToken } = useAuth();

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
